<!-- CSVパターン編集 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<!-- ▽  -->
	<div class="contents" id="csvPtnDtl">
		<!-- ▽ 各種操作ボタン部分 -->
		<section id="mainContent">
			<h2>CSVパターン編集<span>詳細・新規登録</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCansel">戻る</li>
			</ul>
			<section class="selectArea">
				<!-- CSV 追加可能項目 -->
				<section class="csvItemLst">
					<h3>追加可能項目</h3>
						<dl>
							<dt>絞り込み条件</dt>
								<dd>
									<label for="all" class="radio"><input type="radio" id="all" value="0" v-model="inputForm.zkkb"><span>両方</span></label>
									<label for="zokusei" class="radio"><input type="radio" id="zokusei" value="1" v-model="inputForm.zkkb"><span>受診者・予約属性</span></label>
									<label for="option" class="radio"><input type="radio" id="option" value="2" v-model="inputForm.zkkb"><span>オプション項目</span></label>
								</dd>
								<dt>項目名<span>部分一致検索可</span></dt>
								<dd><input type="text" v-model="inputForm.name"></dd>
						</dl>
						<!-- CSV項目 選択 -->
						<ul class="itemLst">
							<li v-for="(item,index) in computedCsvAddList" v-bind:key="item.recordKey">
								<label class="checkbox" v-bind:for="getBindId('csvAddList',index)"><input type="checkbox" name="csvAddList" v-bind:id="getBindId('csvAddList',index)" v-bind:value="item.recordKey" v-model="inputForm.choiceRecordKeyCsvAdd"><span>{{item.name}}</span></label>
							</li>
						</ul>
				</section>
				<ul class="onAddBtn">
					<!-- 追加 --><li v-on:click="onAddToCsvOutList">挿入</li>
					<!-- 追加 --><li v-on:click="onAddLastToCsvOutList">末尾に追加</li>
				</ul>
				<section class="inputArea">
				<!-- ボタン欄 -->
					<table class="inputTbl">
						<caption>
							<div class="btnLst">
								<button class="confBtn" v-on:click="onConfirmRegisterModalOpen">更新</button>
							</div>
						</caption>
						<tbody>
							<tr>
								<th>パターン名</th>
								<td><input type="text" v-model="inputForm.ptnm"></td>
							</tr>
							<tr>
								<th>初期区分</th>
								<td>
									<label for="dffgOff" class="radio"><input type="radio" id="dffgOff" value="1" v-model="inputForm.dffg"><span>初期表示する</span></label>
									<label for="dffgOn" class="radio"><input type="radio" id="dffgOn" value="0" v-model="inputForm.dffg"><span>初期表示しない</span></label>
								</td>
							</tr>
							<tr>
								<th>出力する項目</th>
								<td class="csvOutItemLst">
									<ul class="listController">
										<!-- 上に移動 --><li v-on:click="onUpCsvOutList">▲</li>
										<!-- 下に移動 --><li v-on:click="onDownCsvOutList">▼</li>
										<!--除外 --><li v-on:click="onExceptFromCsvOutList">削除</li>
									</ul>
									<!-- 出力する項目 -->
									<ul class="itemLst">
										<li v-for="(item,index) in computedCsvOutList" v-bind:key="item.nbr">
											<label class="checkbox" v-bind:for="getBindId('csvOutList',index)"><input type="checkbox" name="csvOutList" v-bind:id="getBindId('csvOutList',index)" v-bind:value="item.nbr" v-model="inputForm.choiceNbrCsvOut"><span>{{item.name}}</span></label>
										</li>
									</ul>
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</section>
			<!-- selectArea END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onRegister">OK</button></li>
					<li><button v-on:click="onConfirmRegisterModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { CSVPatternDetailApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'CSVPatternDetail',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		// 算出プロパティ
		computed: {
			// CSV追加可能項目
			computedCsvAddList: function() {
				
				var tempList = this.inputForm.csvAddList.slice()
				
				// 属性区分でフィルターをかけたリスト
				var filteredListByZkkb = []
				// 属性区分及び名前でフィルターをかけたリスト
				var resultList = []

				// 0:両方を選択していなければ属性区分でフィルタをかけて代入
				// 0:両方を選択している場合はそのまま代入
				if('0' != this.inputForm.zkkb) {
					filteredListByZkkb = tempList.filter(item => {
							return item.zkkb == this.inputForm.zkkb
					})
				} else {
					filteredListByZkkb = tempList
				}

				// 項目名に入力がある場合は項目名でフィルタをかけて代入
				// 項目名に入力がない場合はそのまま代入
				if('' != this.inputForm.name) {
					resultList = filteredListByZkkb.filter(item => {
							return item.name.indexOf(this.inputForm.name) > -1
					})
				} else {
					resultList = filteredListByZkkb
				}

				return resultList
			},
			// CSV出力項目
			computedCsvOutList: function() {
				// sortは配列の中身もソートされてしまうため
				// slice()で元の配列のコピーを作成してからソートします。
				var resultList = []
				resultList = this.sortCsvOutListByRecordNumber()

				return resultList
			}
		},
		// データ
		data() {
			return {

				// 入力フォーム
				inputForm: {

					// パターン名
					ptnm: '',

					// 初期区分
					// 0: false、1: true
					dffg: '',

					// 属性区分
					zkkb: '0',

					// 名前（属性項目名またはオプション項目名）
					name: '',

					// CSV追加可能項目
					// recordKey: レコードキー
					//            CSV出力項目の並び順（昇順）に使用する
					//            (ZKKB=1の場合)属性コード（左寄せ１０桁）
					//            (ZKKB=2の場合)オプション分類コード+オプション項目コード
					// zkkb: 属性区分
					//       '1': 予約属性、'2': オプション属性
					// zkcd: 属性コード(ZKKB=1の場合)
					//       '000'(ZKKB=2の場合)
					// opbr: 固定値'0000'(ZKKB=1の場合)
					//       オプション分類コード(ZKKB=2の場合)
					// opcd: 固定値'000000'(ZKKB=1の場合)
					//       オプション項目コード
					// name: 属性項目名(ZKKB=1の場合)
					//       オプション項目名(ZKKB=2の場合)
					csvAddList: [],

					// 選択したCSV追加可能項目のレコードキー
					choiceRecordKeyCsvAdd: [],

					// CSV出力項目
					// recordNumber: レコードナンバー
					//               CSV出力項目の並び順（昇順）に使用する
					//               SQL取得時は固定値0、フロントエンドで初期化時に0始まりで初期化
					//               登録時はCSV_NBRに対応する
					// nbr: 連番
					// zkkb: 属性区分
					//       1: 予約属性、2: オプション属性
					// zkcd: 属性コード
					// opbr: オプション分類コード
					// opcd: オプション項目コード
					// name: 属性項目名もしくはオプション項目名
					// recordStatus: レコードステータス
					//               0:  初期表示時
					//               13: 編集状態（データ更新は一括削除後かつ一括新規登録）
					csvOutList: [],

					// 選択したCSV出力項目の連番
					choiceNbrCsvOut: [],
				},
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmRegister: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルフック
		created: function () {
			UtilityConsoleLog.consoleLog('CSVPatternList::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('CSVPatternList::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::firstDisplay Start')

				CSVPatternDetailApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ptcd: this.$store.state.adminUserChoice.CSVPattern.ptcd,
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.inputForm.ptnm = responce.data.ptnm
						this.inputForm.dffg = responce.data.dffg
						this.inputForm.csvAddList = responce.data.csvAddList
						this.inputForm.csvOutList = responce.data.csvOutList
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CSVPatternDetail::firstDisplay End')
				})
			},
			// CSV出力項目を登録及び更新
			onRegister: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onRegister Start')

				// 登録確認用モーダルを閉じる
				this.onConfirmRegisterModalClose()

				var objectOfCsv2 = {
					recordNumbers: [],
					zkkbs: [],
					zkcds: [],
					opbrs: [],
					opcds: []
				}

				// CSV出力項目から送信用の配列を取得
				objectOfCsv2 = this.getInfoCsv2List()

				// 非同期通信
				CSVPatternDetailApi.Register({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ptcd: this.$store.state.adminUserChoice.CSVPattern.ptcd,
					ptnm: this.inputForm.ptnm,
					dffg: this.inputForm.dffg,
					recordNumbers: objectOfCsv2.recordNumbers,
					zkkbs: objectOfCsv2.zkkbs,
					zkcds: objectOfCsv2.zkcds,
					opbrs: objectOfCsv2.opbrs,
					opcds: objectOfCsv2.opcds
				}).then(({responce}) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 選択したレコードのptcdをstoreに登録
						this.$store.commit(
								types.ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL,
								 {
										 ptcd: responce.data.ptcd
								 }
						)

						this.inputForm.ptnm = responce.data.ptnm
						this.inputForm.dffg = responce.data.dffg
						this.inputForm.csvAddList = responce.data.csvAddList
						this.inputForm.choiceRecordKeyCsvAdd = []
						this.inputForm.csvOutList = responce.data.csvOutList
						this.inputForm.choiceNbrCsvOut = []

					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {

						this.onValidationErrorModalOpen(responce.data.errorMessagesList)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CSVPatternDetail::onRegister End')
				})
			},
			// キャンセル
			onCansel: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onCansel Start')

				// 選択したレコードのptcdをstoreに登録
				this.$store.commit(
						types.ADMIN_USERCHOICE_CSVPATTERN_BACKTOLIST
				)

				this.$router.push("/CSVPatternList")

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onCansel End')
			},
			// 挿入
			// CSV追加可能項目からCSV出力項目追加
			onAddToCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onAddToCsvOutList Start')

				// エラーチェック
				var tempMessages = []
				tempMessages = this.validateOnAddToCsvOutList()

				if(tempMessages.length > 0){
					this.onValidationErrorModalOpen(tempMessages)
					return
				}

				// 選択したCSV追加可能項目オブジェクト
				var choiceObjectFromCsvAddList = this.getArrayCsvAddList(
					this.inputForm.choiceRecordKeyCsvAdd)

				// CSV追加可能項目オブジェクトの情報をもとにCSV出力項目追加
				this.addToCsvOutListFromCsvAddList(choiceObjectFromCsvAddList)

				// レコードナンバーを設定しなおす
				this.formatRecordNumber()

				// 選択したCSV追加可能項目のレコードキーを空にする
				this.inputForm.choiceRecordKeyCsvAdd = []

				// 選択したCSV出力項目の連番を空にする
				this.inputForm.choiceNbrCsvOut = []

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onAddToCsvOutList End')
			},
			// 末尾に追加
			onAddLastToCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onAddLastToCsvOutList Start')

				// エラーチェック
				var tempMessages = []
				tempMessages = this.validateonAddLastToCsvOutList()

				if(tempMessages.length > 0){
					this.onValidationErrorModalOpen(tempMessages)
					return
				}

				// 選択したCSV追加可能項目オブジェクト
				var choiceObjectFromCsvAddList = this.getArrayCsvAddList(
					this.inputForm.choiceRecordKeyCsvAdd)

				// CSV追加可能項目オブジェクトの情報をもとにCSV出力項目を末尾に追加
				this.addLastToCsvOutListFromCsvAddList(choiceObjectFromCsvAddList)

				// 選択したCSV追加可能項目のレコードキーを空にする
				this.inputForm.choiceRecordKeyCsvAdd = []

				// 選択したCSV出力項目の連番を空にする
				this.inputForm.choiceNbrCsvOut = []

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onAddLastToCsvOutList End')
			},
			// 削除
			// CSV出力項目から除外
			onExceptFromCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onExceptFromCsvOutList Start')

				// エラーチェック
				var tempMessages = []
				tempMessages = this.validationOnExceptFromCsvOutList()

				if(tempMessages.length > 0) {
					this.onValidationErrorModalOpen(tempMessages)
					return
				}

				// 現在選択しているCSV追加可能項目オブジェクト以外を抽出して
				// 新しいCSV出力項目リストとする
				var tempArray = this.inputForm.csvOutList.filter(
					item => {
						 return this.inputForm.choiceNbrCsvOut.indexOf(item.nbr) == -1
					})

				this.inputForm.csvOutList = tempArray

				// レコードナンバーを設定しなおす
				this.formatRecordNumber()

				// 選択したCSV追加可能項目のレコードキーを空にする
				this.inputForm.choiceRecordKeyCsvAdd = []

				// 選択したCSV出力項目の連番を空にする
				this.inputForm.choiceNbrCsvOut = []

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onExceptFromCsvOutList End')
			},
			// CSV出力項目の要素を一つ上げる（昇順表示なのでrecordKeyが小さいもの（一番差が少ない）と入れ替え）
			onUpCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onUpCsvOutList Start')

				var tempMessages = []
				tempMessages = this.validationOnUpCsvOutList()

				// 入力エラーがある場合
				if(tempMessages.length > 0){
					this.onValidationErrorModalOpen(tempMessages)
					return
				}

				// 連番からソートされたレコードナンバーを取得
				var tempSortedRecordNumbers = []
				tempSortedRecordNumbers = this.sortAscRecordNumber(this.inputForm.choiceNbrCsvOut)

				for(var i=0;i<tempSortedRecordNumbers.length;i++) {
					// 選択したCSV出力項目のインデックス
					var tempIndexChoice = this.getIndexCsvOutListByRecordNumber(
						tempSortedRecordNumbers[i])
					// 交換対象のCSV出力項目のインデックス
					var tempIndexTarget = this.getUpIndexCsvOutListByRecordNumber(
						tempSortedRecordNumbers[i])

					var tempRecordNumber = this.inputForm.csvOutList[tempIndexChoice].recordNumber
					this.inputForm.csvOutList[tempIndexChoice].recordNumber = this.inputForm.csvOutList[tempIndexTarget].recordNumber
					this.inputForm.csvOutList[tempIndexTarget].recordNumber = tempRecordNumber
				}

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onUpCsvOutList End')
			},
			// CSV出力項目の要素を一つ下げる（昇順表示なのでrecordKeyが1大きいもの（一番差が少ない）と入れ替え）
			onDownCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onDownCsvOutList Start')

				var tempMessages = []
				tempMessages = this.validationOnDownCsvOutList()

				// 入力エラーがある場合
				if(tempMessages.length > 0){
					this.onValidationErrorModalOpen(tempMessages)
					return
				}

				// 連番からソートされたレコードナンバーを取得
				var tempSortedRecordNumbers = []
				tempSortedRecordNumbers = this.sortDescRecordNumber(this.inputForm.choiceNbrCsvOut)

				for(var i=0;i<tempSortedRecordNumbers.length;i++) {
					// 選択したCSV出力項目のインデックス
					var tempIndexChoice = this.getIndexCsvOutListByRecordNumber(
						tempSortedRecordNumbers[i])
					// 交換対象のCSV出力項目のインデックス
					var tempIndexTarget = this.getDownIndexCsvOutListByRecordNumber(
						tempSortedRecordNumbers[i])

					var tempRecordNumber = this.inputForm.csvOutList[tempIndexChoice].recordNumber
					this.inputForm.csvOutList[tempIndexChoice].recordNumber = this.inputForm.csvOutList[tempIndexTarget].recordNumber
					this.inputForm.csvOutList[tempIndexTarget].recordNumber = tempRecordNumber
				}

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onDownCsvOutList End')
			},
			// CSV追加可能項目から要素（配列）取得
			getArrayCsvAddList: function(in_recordKeyArray) {

				var tempArray = []
				tempArray = this.inputForm.csvAddList.filter(
					item => in_recordKeyArray.indexOf(item.recordKey) > -1
				)
				return tempArray
			},
			// onAddToCsvOutListのサブルーチン-----S
			// CSV追加可能項目からCSV出力項目追加リンク押下時エラーチェック
			validateOnAddToCsvOutList: function() {
			
				var tempMessages = []

				// 選択したCSV追加可能項目のレコードキーが0件の場合
				if(this.inputForm.choiceRecordKeyCsvAdd.length == 0) {
					tempMessages.push('追加可能項目が選択されていません')
				}

				// 選択したCSV出力項目の連番が0件の場合
				if(this.inputForm.csvOutList.length > 0
					&& this.inputForm.choiceNbrCsvOut.length == 0) {
					tempMessages.push('挿入する位置が選択されていません')
				}

				return tempMessages
			},
			// CSV追加可能項目オブジェクトの情報をもとにCSV出力項目追加
			addToCsvOutListFromCsvAddList(in_Array) {

				// 登録用の連番
				var tempAddNbr = this.getMaxNbrFromCsvOutList() + 1
				// 選択しているCSV出力項目のレコードナンバー最小値を取得する
				var tempMinRecordNumber = 0
				tempMinRecordNumber = this.getMinChoiceRecordNumberFromCsvOutList()

				// 追加用オブジェクト格納用配列
				var tempAddObjectArray = []
 
				for(var i=0;i<in_Array.length;i++) {
					tempAddNbr +=  i

					// 追加用のオブジェクトを作成
					var tempAddObject = {
						recordNumber: tempMinRecordNumber + i,
						nbr: tempAddNbr,
						zkkb: in_Array[i].zkkb,
						zkcd: in_Array[i].zkcd,
						opbr: in_Array[i].opbr,
						opcd: in_Array[i].opcd,
						name: in_Array[i].name,
						recordStatus: 13
					}

					tempAddObjectArray.push(tempAddObject)
				}
				
				// 選択したCSV出力項目のレコードナンバー以上の
				// CSV出力項目のレコードナンバーを加算する
				this.updateUpCsvOutListRecordNumber(
					tempMinRecordNumber,in_Array.length)

				tempAddObjectArray.forEach((item)=>{
					 this.inputForm.csvOutList.push(item)
				})
			},
			// CSV出力項目から連番の最大値を求める
			getMaxNbrFromCsvOutList: function() {
			
				var result = 0

				this.inputForm.csvOutList.forEach(
					item=>{
						if( item.nbr > result ) {
							result = item.nbr
						}
				})

				return result
			},
			// 選択しているCSV出力項目のレコードナンバー最小値を取得
			// CSV出力項目が0件の時は1
			getMinChoiceRecordNumberFromCsvOutList: function() {
			
				// 選択しているCSV出力項目のレコードナンバー最小値
				var resultMinRecordNumber = 0

				// 選択しているCSV出力項目の連番
				var tempNbrArray = []

				// CSV出力項目の連番からレコードナンバーを取得する
				var tempRecordNumber = []

				if(this.inputForm.csvOutList.length == 0){
					// CSV出力項目が0件の時
					resultMinRecordNumber = 1
				} else if(this.inputForm.csvOutList.length == 1
							&& this.inputForm.choiceNbrCsvOut.length == 1) {
					// CSV出力項目が1件かつ選択しているCSV出力項目が1件の時
					// 登録用の連番
					tempNbrArray = this.inputForm.choiceNbrCsvOut
					// 選択しているCSV出力項目の連番を取得
					tempRecordNumber = this.convertToRecordNumberFromNbr(tempNbrArray)
					// レコードナンバー最小値を取得する
					resultMinRecordNumber = tempRecordNumber[0]
				} else {

					// 登録用の連番
					tempNbrArray = this.inputForm.choiceNbrCsvOut
					// 選択しているCSV出力項目の連番を取得
					tempRecordNumber = this.convertToRecordNumberFromNbr(tempNbrArray)
					// レコードナンバー最小値を取得する
					resultMinRecordNumber = tempRecordNumber.reduce(
							(a,b) => {
								return Math.min(a,b)
						})
				}

				return resultMinRecordNumber
			},
			// CSV出力項目から連番を用いてレコードナンバーを取得する
			convertToRecordNumberFromNbr: function(in_nbrArray) {

				var resultRecordNumber = []

				for(var i=0;i<in_nbrArray.length;i++) {
					var tempObject = this.getObjectCsvOutList(in_nbrArray[i])
					resultRecordNumber.push(tempObject.recordNumber)
				}

				return resultRecordNumber
			},
			// 選択したCSV出力項目のレコードナンバー以上の
			// CSV出力項目のレコードナンバーを加算する
			updateUpCsvOutListRecordNumber: function(in_minRecordNumber,in_increasRecordNumber) {
				this.inputForm.csvOutList.forEach(item=>{
					if(item.recordNumber >= in_minRecordNumber) {
						item.recordNumber += in_increasRecordNumber
					}
				})
			},
			// onAddToCsvOutListのサブルーチン-----E
			// onAddLastToCsvOutListのサブルーチン-----S
			validateonAddLastToCsvOutList: function() {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::validateonAddLastToCsvOutList Start')

				var tempMessages = []

				// 選択したCSV追加可能項目のレコードキーが0件の場合
				if(this.inputForm.choiceRecordKeyCsvAdd.length == 0) {
					tempMessages.push('追加可能項目が選択されていません')
				}

				UtilityConsoleLog.consoleLog('CSVPatternDetail::validateonAddLastToCsvOutList End')

				return tempMessages
			},
			addLastToCsvOutListFromCsvAddList: function(in_Array) {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::addLastToCsvOutListFromCsvAddList Start')

				// 登録用の連番
					var tempAddNbr = this.getMaxNbrFromCsvOutList() + 1
					// CSV出力項目のレコードナンバー最大値を取得する
					var tempMinRecordNumber = 0
					tempMinRecordNumber = this.getMaxRecordNumberFromCsvOutList()

					// 追加用オブジェクト格納用配列
					var tempAddObjectArray = []

					for(var i=0;i<in_Array.length;i++) {
						tempAddNbr +=  i

						// 追加用のオブジェクトを作成
						var tempAddObject = {
							recordNumber: tempMinRecordNumber + i + 1,
							nbr: tempAddNbr,
							zkkb: in_Array[i].zkkb,
							zkcd: in_Array[i].zkcd,
							opbr: in_Array[i].opbr,
							opcd: in_Array[i].opcd,
							name: in_Array[i].name,
							recordStatus: 13
						}

						tempAddObjectArray.push(tempAddObject)
					}

					tempAddObjectArray.forEach((item)=>{
					 this.inputForm.csvOutList.push(item)
					})

				UtilityConsoleLog.consoleLog('CSVPatternDetail::addLastToCsvOutListFromCsvAddList End')
			},
			// CSV出力項目からレコードナンバーの最大値を求める
			getMaxRecordNumberFromCsvOutList: function() {
			
				UtilityConsoleLog.consoleLog('CSVPatternDetail::getMaxRecordNumber Start')

				var result = 0

					this.inputForm.csvOutList.forEach(
						item=>{
							if( item.recordNumber > result ) {
								result = item.recordNumber
							}
					})

				UtilityConsoleLog.consoleLog('CSVPatternDetail::getMaxRecordNumber End')

				return result
			},
			// onAddLastToCsvOutListのサブルーチン-----E
			// onExceptFromCsvOutListのサブルーチン-----S
			validationOnExceptFromCsvOutList: function() {
			
				var tempMessages = []

				// 選択したCSV出力項目の連番が0件の場合
				if(this.inputForm.choiceNbrCsvOut.length == 0) {
					tempMessages.push('削除する項目が選択されていません')
				}

				return tempMessages
			},
			// onExceptFromCsvOutListのサブルーチン-----E
			// onUpCsvOutListのサブルーチン-----S
			// CSV出力項目の要素を一つ上げるリンク押下時
			validationOnUpCsvOutList: function() {
			
				var tempMessages = []
				var sortedRecordNumbers = []

				// CSV出力項目のレコード数が1件以下の場合
				if(this.inputForm.csvOutList.length <= 1) {
					tempMessages.push('現在追加可能項目は1件以下です。')
				}

				if(this.inputForm.choiceNbrCsvOut.length == 0) {
					tempMessages.push('CSV出力項目が選択されていません。')
				}

				// 連番からソートされたレコードナンバーを取得
				sortedRecordNumbers = this.sortAscRecordNumber(this.inputForm.choiceNbrCsvOut)

				if(!this.checkSerialAscNumberCsvOutList(sortedRecordNumbers)) {
					tempMessages.push('順序を入れ替えるCSV出力項目は連続して選択しなければなりません。')
				}

				// 一番小さいレコードナンバーが1の場合
				if(1 == sortedRecordNumbers[0]){
					tempMessages.push('先頭項目を選択しています。')
				}

				return tempMessages
			},
			// 連番から昇順にソートされたレコードナンバーを取得
			sortAscRecordNumber: function(in_nbrs) {
			
				// ソートされたレコードナンバー
				var resultSortedRecordNumbers = []
				// ソートされる前のレコードナンバー
				var tempRecordNumbers = []

				for(var i=0;i<in_nbrs.length;i++) {
					var tempIndex = this.getIndexCsvOutListByNbr(in_nbrs[i])
					var tempChoiceRecordNumber = this.inputForm.csvOutList[tempIndex].recordNumber
					tempRecordNumbers.push(tempChoiceRecordNumber)
				}

				resultSortedRecordNumbers = tempRecordNumbers.slice()

				resultSortedRecordNumbers.sort((a,b) => {
					return (a === b ? 0: a > b ? 1 : -1)
				})

				return resultSortedRecordNumbers
			},
			// ソートされたCSV出力項目が連番（昇順）になっているかどうか確認する
			checkSerialAscNumberCsvOutList(in_sortedRecordNumber) {
			
				var resultFlag = true
				var tempNumber = in_sortedRecordNumber[0]

				for(var i=0;i<in_sortedRecordNumber.length;i++){
					if(tempNumber != in_sortedRecordNumber[i]) {
						resultFlag = false
						break
					}
					tempNumber += 1
				}

				return resultFlag
			},
			// onUpCsvOutListのサブルーチン-----E
			// onDownCsvOutListのサブルーチン-----S
			// CSV出力項目の要素を一つ上げるリンク押下時
			validationOnDownCsvOutList: function() {
			
				var tempMessages = []
				var sortedRecordNumbers = []

				// CSV出力項目のレコード数が1件以下の場合
				if(this.inputForm.csvOutList.length <= 1) {
					tempMessages.push('追加可能項目が選択されていません。')
				}

				if(this.inputForm.choiceNbrCsvOut.length == 0) {
					tempMessages.push('CSV出力項目が選択されていません。')
				}

				// 連番からソートされたレコードナンバーを取得
				sortedRecordNumbers = this.sortDescRecordNumber(this.inputForm.choiceNbrCsvOut)

				if(!this.checkSerialDescNumberCsvOutList(sortedRecordNumbers)) {
					tempMessages.push('順序を入れ替えるCSV出力項目は連続して選択しなければなりません。')
				}

				var tempMaxRecordNumber = this.getMaxRecordNumberFromCsvOutList()
				// 一番大きいレコードナンバーを選択している場合
				if(tempMaxRecordNumber == sortedRecordNumbers[0]){
					tempMessages.push('末尾項目を選択しています。')
				}

				return tempMessages
			},
			// 連番から降順にソートされたレコードナンバーを取得
			sortDescRecordNumber: function(in_nbrs) {
			
				// ソートされたレコードナンバー
				var resultSortedRecordNumbers = []
				// ソートされる前のレコードナンバー
				var tempRecordNumbers = []

				for(var i=0;i<in_nbrs.length;i++) {
					var tempIndex = this.getIndexCsvOutListByNbr(in_nbrs[i])
					var tempChoiceRecordNumber = this.inputForm.csvOutList[tempIndex].recordNumber
					tempRecordNumbers.push(tempChoiceRecordNumber)
				}

				resultSortedRecordNumbers = tempRecordNumbers.slice()

				resultSortedRecordNumbers.sort((a,b) => {
					return (a === b ? 0: a < b ? 1 : -1)
				})

				return resultSortedRecordNumbers
			},
			// ソートされたCSV出力項目が連番（降順）になっているかどうか確認する
			checkSerialDescNumberCsvOutList(in_sortedRecordNumber) {
			
				var resultFlag = true
				var tempNumber = in_sortedRecordNumber[0]

				for(var i=0;i<in_sortedRecordNumber.length;i++){
					if(tempNumber != in_sortedRecordNumber[i]) {
						resultFlag = false
						break
					}
					tempNumber -= 1
				}

				return resultFlag
			},
			// onDownCsvOutListのサブルーチン-----E
			// CSV出力項目から連番を用いて一要素取得
			getObjectCsvOutList: function(in_nbr) {
				var tempArray = []
				tempArray = this.inputForm.csvOutList.filter(
					item => item.nbr == in_nbr
				)
				return tempArray[0]
			},
			// CSV出力項目からレコードナンバーを用いて要素のインデックス
			getIndexCsvOutListByNbr: function(in_nbr) {

				var resultIndex = 0

				for(var i=0;i<this.inputForm.csvOutList.length;i++) {
					if( this.inputForm.csvOutList[i].nbr == in_nbr) {
						resultIndex = i
						break
					}
				}

				return resultIndex
			},
			// CSV出力項目からレコードナンバーを用いて要素のインデックス
			getIndexCsvOutListByRecordNumber: function(in_recordNumber) {

				var resultIndex = 0

				for(var i=0;i<this.inputForm.csvOutList.length;i++) {
					if( this.inputForm.csvOutList[i].recordNumber == in_recordNumber) {
							resultIndex = i
							break
						}
				}

				return resultIndex
			},
			// CSV出力項目からレコードナンバーを用いて小さいレコードナンバー
			// かつ一番差が少ない要素のインデックス
			getUpIndexCsvOutListByRecordNumber: function(in_recordNumber) {

				var resultIndex = 0
				var tempNumber = 0

				for(var i=0;i<this.inputForm.csvOutList.length;i++) {
					if(this.inputForm.csvOutList[i].recordNumber < in_recordNumber
						&& this.inputForm.csvOutList[i].recordNumber > tempNumber) {
							resultIndex = i
							tempNumber = this.inputForm.csvOutList[i].recordNumber
						}
				}

				return resultIndex
			},
			// CSV出力項目からレコードナンバーを用いて大きいレコードナンバー
			// かつ一番差が少ない要素のインデックス
			getDownIndexCsvOutListByRecordNumber: function(in_recordNumber) {

				var resultIndex = 0
				var tempNumber = this.getMaxRecordNumberFromCsvOutList()

				for(var i=0;i<this.inputForm.csvOutList.length;i++) {

					if( in_recordNumber < this.inputForm.csvOutList[i].recordNumber
						&& tempNumber >= this.inputForm.csvOutList[i].recordNumber ) {
							resultIndex = i
							tempNumber = this.inputForm.csvOutList[i].recordNumber
						}
				}

				return resultIndex
			},
			// チェックボックス用 for、idに名前割り当て
			getBindId: function(in_for,in_index) {
				return in_for + String(in_index)
			},
			// チェックボックス用 nameに名前割り当て
			getBindName: function(in_name,in_index) {
				return in_name + String(in_index)
			},
			// 更新
			validationOnRegister: function() {
				var tempMessage = []

				if(this.inputForm.csvOutList.length == 0) {
					tempMessage.push('CSV出力項目は１項目以上の登録が必要です。')
				}

				return tempMessage
			},
			sortCsvOutListByRecordNumber: function() {
			
				// sortは配列の中身もソートされてしまうため
				// slice()で元の配列のコピーを作成してからソートします。

				var resultList = []
				resultList = this.inputForm.csvOutList.slice()

				var tempSortKey = 'recordNumber'

				if(resultList.length > 1){
					resultList.sort((a,b) => {
						a = a[tempSortKey]
						b = b[tempSortKey]
							return (a === b ? 0 : a > b ? 1 : -1)
					})
				}

				return resultList
			},
			getInfoCsv2List: function() {

				var tempObjectOfCsv2 = {
					recordNumbers: [],
					zkkbs: [],
					zkcds: [],
					opbrs: [],
					opcds: []
				}

				var sortedCsvOutList = this.sortCsvOutListByRecordNumber()

				for(var i=0;i<sortedCsvOutList.length;i++) {
					tempObjectOfCsv2.recordNumbers.push(sortedCsvOutList[i].recordNumber)
					tempObjectOfCsv2.zkkbs.push(sortedCsvOutList[i].zkkb)
					tempObjectOfCsv2.zkcds.push(sortedCsvOutList[i].zkcd)
					tempObjectOfCsv2.opbrs.push(sortedCsvOutList[i].opbr)
					tempObjectOfCsv2.opcds.push(sortedCsvOutList[i].opcd)
				}

				return tempObjectOfCsv2
			},
			formatRecordNumber: function() {
				var sortedCsvOutList = this.sortCsvOutListByRecordNumber()
				var tempRecordNumber = 1
				for(var i=0;i<sortedCsvOutList.length;i++){
					var tempIndex = this.getIndexCsvOutListByRecordNumber(sortedCsvOutList[i].recordNumber)
					this.inputForm.csvOutList[tempIndex].recordNumber = tempRecordNumber
					tempRecordNumber += 1
				}
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmRegisterModalOpen: function () {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onConfirmRegisterModalOpen Start')

				// フロント用エラーメッセージ
				var tempErrorMessages = []
				// 入力チェック
				var tempErrorMessages = this.validationOnRegister()

				// 一件でもエラーがあれば入力エラーモーダルウィンドウを開き、処理を中断する
				if( tempErrorMessages.length > 0 ){
					this.onValidationErrorModalOpen(tempErrorMessages)
					return
				}

				this.modalOpen('confirmRegister')

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onConfirmRegisterModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmRegisterModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::onConfirmRegisterModalClose Start')

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog('CSVPatternDetail::onConfirmRegisterModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('CSVPatternDetail::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('CSVPatternDetail::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('CSVPatternDetail::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Master/WCSV/CSVPatternDetail.vue